import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from '../home/Home';
import News from '../pages/News';
import Jouer from '../pages/Jouer';
import Cadeaux from '../pages/Cadeaux';
import './Main.css';

const Main = () => (
  <main>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/news" component={News} />
      <Route exact path="/jouer" component={Jouer} />
      <Route exact path="/cadeaux" component={Cadeaux} />
      <Route exact path='/discord' component={() => { window.location.href = 'https://discord.gg/YC4XPGp'; return null;}}/>
      <Route render={() => <div>Not Found</div>} />
    </Switch>
  </main>
);

export default Main;



// WEBPACK FOOTER //
// ./src/layout/Main.js